
export function isValidObjectId(id) {
  return id && typeof id === 'string' && /^[0-9a-fA-F]{24}$/.test(id);
}

const REDIRECTS = {
  clientID: '/client',
  employeeID: '/employees',
  userID: '/employees'
};


function detectObjectIdParams(route) {
  return Object.keys(route.params || {}).filter(param => /ID$/i.test(param) || param === 'id');
}

function detectObjectIdQueryParams(route) {
  const query = route.query || {};
  return Object.keys(query).filter(param => /ID$/i.test(param) || param === 'id');
}

function getRedirectPath(invalidParams, route, router) {
  const fullPath = route.path;
  const pathParts = fullPath.split('/').filter(part => part);
  
  for (let i = pathParts.length - 1; i >= 2; i--) {
    const parentSegments = pathParts.slice(0, i);
    const parentPath = `/${parentSegments.join('/')}`;
    
    if (routeExists(router, parentPath)) {
      if (invalidParams.includes('id') && invalidParams.length === 1) {
        return parentPath;
      }
      
      const testRoute = { path: parentPath, params: route.params };
      const parentObjectIdParams = detectObjectIdParams(testRoute);
      
      const hasInvalidParentParams = parentObjectIdParams.some(param => {
        const value = route.params[param];
        return value && !isValidObjectId(value);
      });
      
      if (!hasInvalidParentParams) {
        return parentPath;
      } 
    }
  }
  
  for (const param of invalidParams) {
    if (param === 'id') continue; 
    
    for (const [key, path] of Object.entries(REDIRECTS)) {
      if (param.toLowerCase().includes(key.toLowerCase()) && routeExists(router, path)) {
        return path;
      }
    }
  }
  
  if (pathParts.length > 0) {
    const basePath = `/${pathParts[0]}`;
    if (routeExists(router, basePath)) {
      return basePath;
    }
  }
  
  const fallbacks = ['/client', '/employees', '/users', '/'];
  const fallback = fallbacks.find(path => routeExists(router, path)) || '/';
  return fallback;
}

function routeExists(router, path) {
  return router?.resolve(path)?.resolved?.matched?.length > 0;
}

export function ObjectIdValidationGuard(router) {
  return (to, _from, next) => {
    const skipPaths = ['/login', '/forgot-password', '/reset-password', '/', '/privacy-policy', '/terms-of-service'];
    
    if (skipPaths.includes(to.path)) {
      return next();
    }

    const objectIdParams = detectObjectIdParams(to);
    const invalidRouteParams = objectIdParams.filter(param => {
      const value = to.params[param];
      return value && !isValidObjectId(value);
    });

    const objectIdQueryParams = detectObjectIdQueryParams(to);
    const invalidQueryParams = objectIdQueryParams.filter(param => {
      const value = to.query[param];
      return value && !isValidObjectId(value);
    });

    const allInvalidParams = [...invalidRouteParams, ...invalidQueryParams];

    if (allInvalidParams.length > 0) {
      const redirectPath = getRedirectPath([...invalidRouteParams, ...invalidQueryParams], to, router);
      return next({ path: redirectPath, replace: true });
    }

    next();
  };
}